export default __webpack_public_path__ + "static/media/mc_img_02.2acc8e45.png";